/**
 * Detects Apple platforms so shortcut hints can show ⌘ instead of Ctrl.
 *
 * `navigator.userAgentData.platform` is the current API; `navigator.platform` is
 * still what Safari and Firefox expose. Both are read through a narrow type so we
 * never reach for `any`.
 */
export function isMacPlatform(): boolean {
    const nav = navigator as Navigator & {
        userAgentData?: { platform?: string };
    };
    const platform = nav.userAgentData?.platform ?? nav.platform ?? '';
    return /mac|iphone|ipad|ipod/i.test(platform);
}
